<body class="device-admin">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [filterDisabled]="!isFilterEnabled"
    [rightPadding]="11"
    [hasAddItem]="rolesUtils.canAddEditDeleteDeviceAdmin(currentUserRole)"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addDevice()"
  ></app-table-header>
  <div class="device-table-container">
    <table mat-table matSort [dataSource]="dataSource" class="device-table">
      <caption>
        Device Admin
      </caption>
      <!-- Employee ID -->
      <ng-container matColumnDef="employeeId">
        <th mat-header-cell *matHeaderCellDef id="route-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.EMPLOYEE_ID"
            [control]="employeeIdData.formControl"
            [maxLength]="15"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="route-headers"
          class="left-data-column"
        >
          {{ admin.employeeId }}
        </td>
      </ng-container>

      <!-- Driver ID -->
      <ng-container matColumnDef="driverId">
        <th mat-header-cell *matHeaderCellDef id="route-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.DRIVER_ID"
            [control]="driverIdData.formControl"
            [maxLength]="10"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="route-headers"
          class="left-data-column"
        >
          {{ admin.driverId }}
        </td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef id="email-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.EMAIL"
            [control]="emailData.formControl"
            [maxLength]="50"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="email-headers"
          class="left-data-column"
        >
          {{ admin.email }}
        </td>
      </ng-container>

      <!-- Last Name -->
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef id="email-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LAST_NAME"
            [control]="lastNameData.formControl"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHA_SPACE_ONLY"
            [maxLength]="30"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="email-headers"
          class="left-data-column"
        >
          {{ admin.lastName }}
        </td>
      </ng-container>

      <!-- First Name -->
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef id="email-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.FIRST_NAME"
            [control]="firstNameData.formControl"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHA_SPACE_ONLY"
            [maxLength]="30"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="email-headers"
          class="left-data-column"
        >
          {{ admin.firstName }}
        </td>
      </ng-container>

      <!-- Last Used -->
      <ng-container matColumnDef="lastUsed">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          id="lastUsed-headers"
          onKeyDown="sortData(displayedColumns[5])"
          (click)="sortData(displayedColumns[5])"
        >
          <app-table-sorting-box
            [title]="COLUMNTEXT.LAST_USED"
            [sortAddedAsc]="sortLastUsedAsc"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let device"
          headers="lastUsed-headers"
          class="left-data-column"
        >
          {{ device.lastLoggedIn | date: "yyyy/MM/dd" }}
        </td>
      </ng-container>

      <!-- Added -->
      <ng-container matColumnDef="addedDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          id="added-headers"
          onKeyDown="sortData(displayedColumns[6])"
          (click)="sortData(displayedColumns[6])"
        >
          <app-table-sorting-box
            [title]="COLUMNTEXT.ADDED"
            [sortAddedAsc]="sortAddedAsc"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let device"
          headers="added-headers"
          class="left-data-column"
        >
          {{ device.insertTime | date: "yyyy/MM/dd" }}
        </td>
      </ng-container>

      <!-- Added By -->
      <ng-container matColumnDef="addedBy">
        <th mat-header-cell *matHeaderCellDef id="email-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.ADDED_BY"
            [control]="addedByData.formControl"
            [maxLength]="15"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="email-headers"
          class="left-data-column"
        >
          {{ admin.addedBy }}
        </td>
      </ng-container>

      <!-- OS -->
      <ng-container matColumnDef="os">
        <th mat-header-cell *matHeaderCellDef id="driver-id-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.OS"
            [control]="osData.formControl"
            [maxLength]="10"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="driver-id-headers"
          class="left-data-column"
        >
          {{ admin.os }}
        </td>
      </ng-container>

      <!-- Build -->
      <ng-container matColumnDef="buildVersion">
        <th mat-header-cell *matHeaderCellDef id="serialNumber-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.BUILD_VERSION"
            [control]="buildData.formControl"
            [maxLength]="30"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="serialNumber-headers"
          class="left-data-column"
        >
          {{ admin.buildVersion | uppercase }}
        </td>
      </ng-container>

      <!-- Model -->
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef id="serialNumber-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.MODEL"
            [control]="modelData.formControl"
            [maxLength]="30"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="serialNumber-headers"
          class="left-data-column"
        >
          {{ admin.model | uppercase }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef id="status-headers">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.ENABLED"
            [data]="enabledData"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, enabledData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="status-headers"
          class="extra-left-data-column"
        >
          <img
            [src]="admin.enabled ? IMAGE_SRC.ACTIVE : IMAGE_SRC.CANCEL"
            alt="admin-status"
          />
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="actions">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="actions-headers"
          class="action-column"
        >
          <ion-row class="th-text">{{ CONSTANTS.ACTIONS }} </ion-row>
          <ion-row class="search-wrapper"> </ion-row>
        </th>
        <td mat-cell *matCellDef="let admin" headers="actions-headers">
          <app-table-action-cell
            [data]="admin"
            [hasEditButton]="
              rolesUtils.canAddEditDeleteDeviceAdmin(currentUserRole)
            "
            [hasDeleteButton]="
              rolesUtils.canAddEditDeleteDeviceAdmin(currentUserRole)
            "
            [deleteButtonDisabled]="!!admin.enabled"
            (emitDeleteButton)="deleteDevice(admin)"
            (emitEditButton)="editDevice(admin)"
          ></app-table-action-cell>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row no-results" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
